import { COUNT_DOWN_FORMAT } from '../../constants';

export const addZero = num => num < 10 ? `0${num}` : num;

export const parseTimeTillEnd = (timeTillEnd, format) => {
    const { days, hours, minutes, seconds } = timeTillEnd;

    switch (format) {
        case COUNT_DOWN_FORMAT.mmSS:
            return [
                addZero(minutes),
                addZero(seconds)
            ];
        case COUNT_DOWN_FORMAT.hhMM:
            return [
                hours,
                addZero(minutes)
            ];
        case COUNT_DOWN_FORMAT.ddHHmm:
            return [
                days,
                hours,
                addZero(minutes)
            ];
        default:
            return [
                days,
                hours,
                addZero(minutes),
                addZero(seconds)
            ];
    }
};

export const minsToRaw = mins => mins * 60000;
